import axios from "axios";

const payment = axios.create({
   //baseURL: "http://localhost:3000",
   //baseURL: "https://backend-stnweb.netlify.app",
   baseURL:"https://payment-stnweb.vercel.app"
});

export default payment;